// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/dts-css-modules-loader/index.js??ref--6-1!../../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../../node_modules/postcss-loader/src/index.js??ref--6-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-4!./member-singup.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../node_modules/style-loader/addStyles.js")(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/dts-css-modules-loader/index.js??ref--6-1!../../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../../node_modules/postcss-loader/src/index.js??ref--6-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-4!./member-singup.scss", function() {
			var newContent = require("!!../../../node_modules/dts-css-modules-loader/index.js??ref--6-1!../../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../../node_modules/postcss-loader/src/index.js??ref--6-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-4!./member-singup.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}